import { PromptTemplateCategory } from '../types';

export const dialogue: PromptTemplateCategory = {
  title: "Dialog",
  icon: "💬",
  templates: [
    {
      title: "Template Wawancara Podcast",
      content: `Tulis wawancara gaya podcast antara dua pembicara.
- Pembicara 1 adalah pembawa acara: [seorang jurnalis teknologi yang penasaran dan antusias].
- Pembicara 2 adalah tamu: [seorang peneliti AI terkenal yang baru saja menerbitkan makalah terobosan].
- Topik diskusi adalah [masa depan kolaborasi manusia-AI di bidang kreatif].
- Nadanya harus [percakapan, mendalam, dan sesekali humoris].
- Sertakan pertukaran alami dengan pertanyaan lanjutan dan anekdot.

Format setiap baris sebagai "Speaker 1:" atau "Speaker 2:" diikuti dialog mereka.`,
      mode: 'multi'
    },
    {
      title: "Template Debat",
      content: `Tulis debat terstruktur antara dua pembicara dengan sudut pandang yang berlawanan.
- Pembicara 1 berargumen [mendukung kerja jarak jauh menjadi standar permanen].
- Pembicara 2 berargumen [bahwa kolaborasi di kantor sangat penting untuk inovasi].
- Kedua pembicara harus menyajikan [argumen yang masuk akal dengan contoh dunia nyata].
- Nadanya harus [sopan tetapi penuh semangat].
- Setiap pembicara harus merespons langsung poin lawan bicaranya.

Format setiap baris sebagai "Speaker 1:" atau "Speaker 2:" diikuti dialog mereka.`,
      mode: 'multi'
    },
    {
      title: "Template Dialog Pembelajaran Bahasa",
      content: `Tulis dialog percakapan antara dua pembicara untuk pelajar bahasa.
- Skenarionya adalah [memesan makanan di pasar jalanan yang ramai].
- Pembicara 1 adalah [penjual lokal yang ramah merekomendasikan hidangan terbaik mereka].
- Pembicara 2 adalah [seorang pelancong yang mencoba masakan lokal untuk pertama kalinya].
- Sertakan [keraguan alami, ungkapan sopan, dan konteks budaya].
- Dialog harus terasa autentik dan membantu pelajar dengan [ungkapan percakapan sehari-hari].

Format setiap baris sebagai "Speaker 1:" atau "Speaker 2:" diikuti dialog mereka.`,
      mode: 'multi'
    }
  ]
};
